import { render } from "./orderApplyAfterSales.vue?vue&type=template&id=5c444f28&scoped=true"
import script from "./orderApplyAfterSales.vue?vue&type=script&lang=js"
export * from "./orderApplyAfterSales.vue?vue&type=script&lang=js"

import "./orderApplyAfterSales.vue?vue&type=style&index=0&id=5c444f28&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c444f28"]])

export default __exports__